import Course from "./routes/Course";
import AttendenceManager from "AttendanceManager";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import MyCalendar from "Course/routes/MyCalendar";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
import { injectReducer } from "store/reducers";

import Projects from "../Projects";

export default store => {
  return {
    path: "courses",
    component: withAsyncRouteLoading(
      () =>
        new Promise((resolve, reject) => {
          require.ensure(
            [],
            require => {
              const component = require("./components").default;

              const coursesModule = require("Courses/modules/CoursesModule")
                .default;
              const coursesModuleKey = require("Courses/modules/CoursesModule")
                .NAME;

              const classRoomReducer = require("ClassRoom/modules/ClassRoomModule")
                .default;

              const organizationResoucesReducer = require("AppComponents/OrganizationResources/modules/OrganizationResourcesModule")
                .default;
              const organizationResoucesReducerKey = require("AppComponents/OrganizationResources/modules/OrganizationResourcesModule")
                .NAME;

              const assignmentAndDeadineReducer = require("AppComponents/AssignmentAndDeadlines/modules/AssignmentAndDeadlineModules")
                .default;
              const assignmentAndDeadineReducerKey = require("AppComponents/AssignmentAndDeadlines/modules/AssignmentAndDeadlineModules")
                .NAME;

              const LearningCoursesListReducer = require("LearningCoursesList/modules/LearningCoursesListModule")
                .default;

              const LearningCoursesListReducerKey = require("LearningCoursesList/modules/LearningCoursesListModule")
                .NAME;

              const LearningCoursesReducer = require("LearningCourses/modules/LearningCoursesModule")
                .default;

              const LearningCoursesReducerKey = require("LearningCourses/modules/LearningCoursesModule")
                .NAME;

              const classSetupReducerReducer = require("CourseSetup/modules/Module")
                .default;

              const classSetupReducerKey = require("CourseSetup/modules/Module")
                .NAME;

              injectReducer(store, {
                key: coursesModuleKey,
                reducer: coursesModule,
              });
              injectReducer(store, {
                key: "classRoom",
                reducer: classRoomReducer,
              });
              injectReducer(store, {
                key: organizationResoucesReducerKey,
                reducer: organizationResoucesReducer,
              });
              injectReducer(store, {
                key: assignmentAndDeadineReducerKey,
                reducer: assignmentAndDeadineReducer,
              });
              injectReducer(store, {
                key: LearningCoursesListReducerKey,
                reducer: LearningCoursesListReducer,
              });
              injectReducer(store, {
                key: LearningCoursesReducerKey,
                reducer: LearningCoursesReducer,
              });
              injectReducer(store, {
                key: classSetupReducerKey,
                reducer: classSetupReducerReducer,
              });
              resolve(component);
            },
            err => {
              reject(err);
            },
            "teacher-course"
          );
        })
    ),
    childRoutes: [
      AttendenceManager(store),
      MyCalendar(store),
      Course(store),
      AssessmentDetails(store),
      ClassRoomDetails(store),
      Projects(store),
    ],
  };
};
